import { apiClient } from "../apiClient";
export const NGANH_XET_TUYEN_ENDPOINT = "nganh-xet-tuyen";
export const nganhXetTuyenApi = {
  SelectAll: () => apiClient.get(`${NGANH_XET_TUYEN_ENDPOINT}`),
};
